module.exports = __webpack_public_path__ + "static/media/ProductUnhideBlue.80daacf2.svg";